import React from "react";

function money(v) {
  const n = Number(v || 0);
  return `$${n.toFixed(2)}`;
}

export default function ReviewEventCard({
  event,
  eventImage,
  startDateLabel,
  startTimeLabel,
  currentDayPrice,
  hideDayPrice = false,
}) {
  return (
    <div className="review-event-box">
      <div className="review-event-top">
        <div className="review-event-main">
          {eventImage ? <img src={eventImage} alt="" className="review-event-img" /> : null}
          <div>
            <div className="review-event-name">{event?.name || event?.title || "Event"}</div>
            <div className="review-event-address">{event?.address || "Address not available"}</div>
            <div className="review-event-meta">
              {startDateLabel}
              {startTimeLabel ? ` • ${startTimeLabel}` : ""}
            </div>
          </div>
        </div>
        {!hideDayPrice && currentDayPrice != null ? (
          <div className="review-event-day-price">{money(currentDayPrice)}</div>
        ) : null}
      </div>
    </div>
  );
}
